import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import { actions } from "./thirdPartyApp.actions";
import { getters } from "./thirdPartyApp.getters";
import { mutations } from "./thirdPartyApp.mutations";
import { state } from "./thirdPartyApp.state";
import { ThirdPartyAppState } from "./thirdPartyApp.types";

const namespaced: boolean = true;

export const ThirdPartyAppModule: Module<ThirdPartyAppState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
